import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/img/empty.png';
const _hoisted_1 = {
  class: "custom-card"
};
const _hoisted_2 = {
  class: "p-15 pt-10 bg-white",
  style: {
    "position": "relative"
  }
};
import { VxeColumn } from 'vxe-table';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useRoute, useRouter } from 'vue-router';
import { useCommon } from '@/common/hooks/useCommon';
import { useLayoutStore } from '@/store';
import { useDownload } from '@/common/hooks/useDownload';
import { useTable } from '@/common/hooks/useTable';
import { useUpload } from '@/common/hooks/useUpload';
import OperationManualController from '@/api/system/OperationManualController';

import { ref, reactive, onMounted } from 'vue';
const __default__ = {
  name: 'formPlant'
};
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const layoutStore = useLayoutStore();
    const {
      downloadFile
    } = useDownload();
    const {
      getUploadHeaders,
      getUploadActionUrl,
      fileListToJson,
      parseUploadData,
      fetchUpload
    } = useUpload();
    const {
      Delete,
      Search,
      Edit,
      Plus,
      Refresh,
      Picture,
      Dialog,
      mainContextHeight,
      clientHeight,
      checkPermCodeExist,
      parseParams,
      parseArrayParams,
      formatDateByStatsType,
      getDateRangeFilter
    } = useCommon();
    const form = ref();
    const onCancel = () => {
      layoutStore.removeCachePage(route.name);
      route.meta.refreshParentCachedPage = true;
      router.go(-1);
    };
    /**
     * 表格组件数据获取函数，返回Promise
     */
    const loadFileList = params => {
      if (params == null) params = {};
      params.operationManualDtoFilter = {
        name: formData.formFilterCopy.name
      };
      return new Promise((resolve, reject) => {
        OperationManualController.list(params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    };
    /**
     * 表格组件数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    const loadFileTableVerify = () => {
      formData.formFilterCopy.name = formData.formFilter.name;
      return true;
    };
    /**
     * 导入
     */
    const onImportPlantClick = file => {
      let params = {
        importFile: file.raw,
        // 是否忽略表头
        skipHeader: true
      };
      OperationManualController.import(params).then(res => {
        ElMessage.success('导入成功');
        formFileTableWidget.refreshTable();
      }).catch(e => {
        // TODO: 异常处理
        console.error(e);
      });
    };
    /**
     * 删除
     */
    const onDeletePlantClick = row => {
      let params = {
        id: row?.id
      };
      console.log(row);
      console.log(formData.fileList.impl.dataList);
      ElMessageBox.confirm('是否删除此记录？').then(res => {
        OperationManualController.delete(params).then(res => {
          ElMessage.success('删除成功');
          refreshFormData(false);
        }).catch(e => {
          // TODO: 异常处理
          console.error(e);
        });
      }).catch(e => {
        // TODO: 异常处理
        console.error(e);
      });
    };
    // 表格组件表格组件参数
    const tableOptions = {
      loadTableData: loadFileList,
      verifyTableParameter: loadFileTableVerify,
      paged: false,
      rowSelection: false,
      orderFieldName: undefined,
      ascending: true
    };
    // 表格组件表格组件
    const formTable = ref();
    const formData = reactive({
      formFilter: {
        name: undefined
      },
      formFilterCopy: {
        name: undefined
      },
      fileList: {
        impl: useTable(tableOptions)
      }
    });
    const refreshFormData = (reloadData = false) => {
      // 重新获取数据组件的数据
      if (reloadData) {
        formData.fileList.impl.refreshTable(true, 1);
      } else {
        formData.fileList.impl.refreshTable();
      }
    };
    const onReset = () => {
      form.value.resetFields();
      refreshFormData(true);
    };
    const onUploadFile = raw => {
      const file = raw.file;
      const action = getUploadActionUrl('/admin/app/attachment/upload');
      const data = {
        uploadFile: file,
        fieldName: 'content',
        asImage: false
      };
      fetchUpload(action, data).then(res => {
        console.log(res);
        const result = [{
          name: file.name,
          ...res
        }];
        const params = {
          attachmentDto: {
            content: JSON.stringify(result)
          },
          operationManualDto: {}
        };
        OperationManualController.add(params).then(() => {
          refreshFormData(true);
        });
      });
    };
    const onDownload = row => {
      console.log(row);
      const data = row.attachment;
      if (data.content) {
        let downloadParams = {
          id: data.id,
          fieldName: 'content',
          asImage: false
        };
        const result = parseUploadData(data.content, downloadParams);
        if (result.length) {
          downloadFile(result[0].url, result[0].name);
        }
      }
    };
    /**
     * 重置所有过滤值
     */
    onMounted(() => {
      refreshFormData(true);
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_table_box = _resolveComponent("table-box");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_table_box, {
        ref_key: "formTable",
        ref: formTable,
        data: _unref(formData).fileList.impl.dataList,
        size: _unref(layoutStore).defaultFormItemSize,
        "row-config": {
          isCurrent: false,
          isHover: true
        },
        "seq-config": {
          startIndex: (_unref(formData).fileList.impl.currentPage - 1) * _unref(formData).fileList.impl.pageSize
        },
        "sort-config": {
          remote: true
        },
        hasExtend: false,
        onSortChange: _unref(formData).fileList.impl.onSortChange,
        onRefresh: _cache[0] || (_cache[0] = $event => refreshFormData(true))
      }, {
        empty: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("div", {
          class: "table-empty unified-font"
        }, [_createElementVNode("img", {
          src: _imports_0
        }), _createElementVNode("span", null, "暂无数据")], -1)])),
        default: _withCtx(() => [_createVNode(_unref(VxeColumn), {
          title: "序号",
          type: "seq",
          index: _unref(formData).fileList.impl.getTableIndex,
          width: 50,
          align: "center"
        }, null, 8, ["index"]), _createVNode(_unref(VxeColumn), {
          title: "文件名称",
          field: "name"
        }), _createVNode(_unref(VxeColumn), {
          title: "操作",
          fixed: "right",
          width: "60"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: _unref(layoutStore).defaultFormItemSize,
            onClick: _withModifiers($event => onDownload(scope.row), ["stop"])
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode(" 下载 ")])),
            _: 2
          }, 1032, ["size", "onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "size", "seq-config", "onSortChange"])])]);
    };
  }
});